// extracted by mini-css-extract-plugin
export var separator = "styles-module--separator--2Rv0_";